import type { IPortalSessionResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

export class BillingService {
    constructor(private api: ApiClient) {}

    /**
     * Open a Stripe Billing Portal session (ESCLOUD-290). The returned URL is
     * short-lived and single-use — redirect to it immediately. 404
     * `no_billing_profile` when the workspace has no Stripe customer to
     * manage (mock billing, or no checkout ever started).
     */
    createPortalSession(tenantId: string): Promise<IPortalSessionResponse> {
        return this.api.post<IPortalSessionResponse>(`/tenants/${tenantId}/billing/portal-session`);
    }
}
